import { Icon, Span } from "@icg360/design-system";

import { type KeystoneMortgageeInfo } from "utils/keystone-api-mapping";

import styles from "./edit-mortgagee-modal.module.scss";

export const ADD_MY_OWN_ITEM: KeystoneMortgageeInfo = {
  index: "addMore",
  name: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zipCode: "",
};

export const NO_RESULTS_ITEM: KeystoneMortgageeInfo = {
  index: "noResults",
  name: "No results found",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zipCode: "",
};

export const TYPE_TO_SEARCH_ITEM: KeystoneMortgageeInfo = {
  index: "typeToSearch",
  name: "Type to search",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  zipCode: "",
};

type MortgageeItemProps = {
  mortgagee: KeystoneMortgageeInfo;
};

export const MortgageeItem = ({ mortgagee }: MortgageeItemProps) => {
  if (mortgagee === ADD_MY_OWN_ITEM) {
    return <AddMyOwnItem />;
  }

  return (
    <div>
      <div>{mortgagee.name}</div>
      {mortgagee.addressLine1 ? (
        <div>
          <Span size="sm" color="quiet">
            {mortgagee.addressLine1} {mortgagee.addressLine2} {mortgagee.city},{" "}
            {mortgagee.state} {mortgagee.zipCode}
          </Span>
        </div>
      ) : null}
    </div>
  );
};

const AddMyOwnItem = () => {
  return (
    <div className={styles.addMyOwn}>
      <Icon name="AddCircle" /> Add my own
    </div>
  );
};
